/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from '../types/index';

function IllustStatusForbidden({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 200 200"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fill="#B6BAC1"
        fillRule="evenodd"
        d="M86.722 40.75c16.23 0 29.439 13.21 29.439 29.44v8.54h4.24c8.577 0 15.531 6.954 15.531 15.53v48.07c-.001 8.577-6.954 15.53-15.531 15.53h-67.35c-8.576 0-15.53-6.953-15.53-15.53V94.26c0-8.576 6.954-15.53 15.53-15.53h4.23v-8.54c0-16.23 13.21-29.44 29.44-29.44m-33.67 40.48c-7.196 0-13.03 5.834-13.03 13.03v48.07c0 7.196 5.834 13.03 13.03 13.03H120.4c7.196 0 13.03-5.834 13.031-13.03V94.26c0-7.196-5.834-13.03-13.031-13.03zm33.67-37.98c-14.85 0-26.94 12.09-26.94 26.94v8.54h10.49v-8.54c0-9.07 7.38-16.45 16.45-16.45s16.45 7.38 16.45 16.45v8.54h10.489v-8.54c0-14.85-12.09-26.94-26.94-26.94m0 12.99c-7.69 0-13.95 6.26-13.95 13.95v8.54h27.9v-8.54c0-7.69-6.26-13.95-13.95-13.95"
        clipRule="evenodd"
      />
      <path
        fill="#FAE100"
        d="M152.551 102.97h-63.9c-8.582 0-15.54 6.957-15.54 15.54v5.94c0 8.582 6.958 15.54 15.54 15.54h63.9c8.583 0 15.54-6.958 15.54-15.54v-5.94c0-8.583-6.957-15.54-15.54-15.54"
      />
      <path
        fill="#F9FAFB"
        d="M97.662 126.08a4.6 4.6 0 1 0 0-9.2 4.6 4.6 0 0 0 0 9.2m16.209 0a4.6 4.6 0 1 0 .001-9.199 4.6 4.6 0 0 0-.001 9.199m16.21 0a4.6 4.6 0 1 0 .001-9.199 4.6 4.6 0 0 0-.001 9.199m16.21 0a4.6 4.6 0 1 0 .001-9.199 4.6 4.6 0 0 0-.001 9.199"
      />
    </svg>
  );
}
export default IllustStatusForbidden;
